"use strict";
import vueCookie from 'vue-cookie'

import Home_vue from '@/vue/apps/home/home.vue'
import Vue from 'vue'
import store from '@/vue/store/'
new Vue({
  el: '#Home2',
  template: '<Home ></Home>',
  store: store,
  data: {
    account: window.account,
  },
  beforeMount() {
    if(vueCookie.get(window.compcode + '_acc')){
      var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
      window.account.shownGuide = accCookie.shownGuide ? true : false
    }
    this.$store.commit('ACCOUNT', window.account);
    this.$store.commit('BETLANG', window.lang.betting);
    this.$store.commit('ODDTYPESLIST', window.odds);
    this.$store.commit('EARLYPARLAYDATELIST', window.earlyParlayDateList);
    this.$store.commit('BETTYPELANG', window.lang.betTypeLang);
    this.$store.commit('SPORTALLBETLANG', window.lang.sportAllBet);
    this.$store.commit('SPORTFORECAST_LANG', window.lang.sportForecast);
  },
  components: {
    Home: Home_vue
  },
})



// WEBPACK FOOTER //
// ./resources/wob/js/home/home.js